import React, { useCallback } from 'react';
import { Row, Card } from 'reactstrap';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import {
  individual_column_style,
  individual_header_style,
  individual_icon_header_style,
  icon_column_style
} from 'assets/styles/table_custom_style';

import { TotalRegister } from '../../../../../components/TotalRegister';
import EditModal from '../assets/components/EditModal';
import ConversationDetails from 'components/Conversation/ConversationDetails';
import { TagChatClient } from 'components/TagChatClient';
import { IconsChannel } from 'components/IconsChannel/IconsChannel';
import { Link, useHistory } from 'react-router-dom';
import { EditProtocolByNumber } from 'views/Protocol/list/components/ProtocolList/styled';
import { PhoneCell } from 'components/FlexTable/components/cells/phone';

// Estilos constantes para evitar re-renderizações
const linkStyle = {
  color: '#5e72e4',
  textDecoration: 'underline'
};

const Analytical = ({
  dataReport,
  totalRegister,
  isMultiDownload = false,
  selectedConversations = [],
  setSelectedConversations = () => {}
}) => {
  const history = useHistory();
  const removeHtmlTags = (str) => {
    if (str) return str.replace(/<[^>]*>/g, ' ');
    return str;
  };
  const data = (dataReport.conversas || [])
    .filter((item) => item._id || item.id)
    .map((item) => ({
      ...item,
      uniqueId: item._id || item.id
    }));

  const handleUpdate = useCallback(
    (id, selectedRecordTypeId) => {
      if (!selectedRecordTypeId) {
        throw new Error('Record type id is required');
      }
      const values = {
        recordTypeId: selectedRecordTypeId,
        returnPath: '/admin/report/chat/conversation'
      };
      const objetoString = JSON.stringify(values);
      localStorage.setItem('valueRoute', objetoString);

      history.push(`/admin/protocol/${id}/update`);
    },
    [history]
  );

  return (
    <>
      <Row className="mt-3">
        <div className="col">
          <div className="card-wrapper">
            {totalRegister >= 0 && (
              <TotalRegister totalRegister={totalRegister} />
            )}
            <Card>
              <ToolkitProvider
                data={data}
                keyField="uniqueId"
                columns={[
                  {
                    dataField: 'atendente.name',
                    text: 'Usuário',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'atendimentoBot',
                    text: 'CPF/CNPJ',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style,
                    formatter: (_, row) => {
                      if (row.resumoBot) {
                        const resumos = row.resumoBot;
                        const KEYCPF = 'CPF';
                        const KEYCPFANDCNPF = 'CPF/CNPJ';
                        let cpfCnpj = '';

                        for (const resumo of resumos) {
                          if (
                            resumo.id === KEYCPF ||
                            resumo.id === KEYCPFANDCNPF
                          ) {
                            cpfCnpj = resumo.value;
                          }
                        }

                        return cpfCnpj;
                      } else {
                        return '';
                      }
                    }
                  },
                  {
                    dataField: 'cliente.nome',
                    text: 'Cliente',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'tags',
                    text: 'Tags do Cliente',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style,
                    formatter: (cell) => {
                      return (
                        <div
                          style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            maxWidth: '13.75rem',
                            width: '13.75rem',
                            wordWrap: 'break-word',
                            paddingTop: '0.6rem',
                            backgroundColor: '#fff'
                          }}
                        >
                          {cell?.length > 0 &&
                            cell.map((tag, index) => {
                              return (
                                <TagChatClient
                                  key={index}
                                  name={tag?.name}
                                  isMore={false}
                                  color={tag?.color}
                                  disabled={false}
                                  index={index}
                                  sizeText="auto"
                                  inPopover={true}
                                />
                              );
                            })}
                        </div>
                      );
                    }
                  },
                  {
                    dataField: 'cliente.telefone',
                    text: 'Telefone',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style,
                    formatter: (_, row) => {
                      return (
                        <PhoneCell
                          phone={row.cliente.telefone}
                          ddi={row.cliente.ddi}
                        />
                      );
                    }
                  },
                  {
                    dataField: 'fila',
                    text: 'Fila',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'hora_criacao',
                    text: 'Início da conversa',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style,
                    formatter: (rowContent) => {
                      const data = new Date(rowContent);
                      return `${data.toLocaleDateString(
                        'pt-br'
                      )} - ${data.toLocaleTimeString('pt-br')}`;
                    }
                  },
                  {
                    dataField: 'nameBroadCastList',
                    text: 'Lista de Transmissão',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'canal',
                    text: 'Canal',
                    formatter: (_, row) => {
                      return <IconsChannel channel={row?.canal} />;
                    },
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'apelidoCanal',
                    text: 'Nome do Canal',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'protocolNumber',
                    text: 'Protocolo',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style,
                    formatter: (_, row) => {
                      const { id, idProtocolo, protocolNumber, recordTypeId } =
                        row;

                      if (!protocolNumber && !recordTypeId) {
                        return <span />;
                      }

                      return (
                        <Link
                          to={`/admin/protocol/${idProtocolo}/update`}
                          onClick={() => handleUpdate(id, recordTypeId)}
                        >
                          <EditProtocolByNumber
                            style={{ color: '#515151' }}
                            title={`Clique para visualizar o protocolo ${protocolNumber}`}
                          >
                            {protocolNumber && protocolNumber}
                          </EditProtocolByNumber>
                        </Link>
                      );
                    }
                  },
                  {
                    dataField: 'observacao',
                    text: 'Observação',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style,
                    formatter: (cell) => (
                      <div
                        style={{
                          maxWidth: '500px',
                          overflowX: 'auto',
                          scrollbarWidth: 'thin'
                        }}
                      >
                        {removeHtmlTags(cell)}
                      </div>
                    )
                  },
                  {
                    dataField: 'leadAssociado',
                    text: 'Lead Associado',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style,
                    formatter: (cell) => {
                      if (!cell || !cell.name || !cell.id)
                        return <span>-</span>;

                      return (
                        <Link
                          to={`/admin/crm/leadEdit/${cell.recordTypeId}/${cell.id}`}
                          style={linkStyle}
                          title={`Ver detalhes do Lead: ${cell.name}`}
                        >
                          {cell.name}
                        </Link>
                      );
                    }
                  },
                  {
                    dataField: 'oportunidadeAssociada',
                    text: 'Oportunidade Associada',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style,
                    formatter: (cell) => {
                      if (!cell || !cell.title || !cell.id)
                        return <span>-</span>;

                      return (
                        <Link
                          to={`/admin/crm/opportunityEdit/${cell.recordTypeId}/${cell.id}`}
                          style={linkStyle}
                          title={`Ver detalhes da Oportunidade: ${cell.title}`}
                        >
                          {cell.title}
                        </Link>
                      );
                    }
                  },
                  {
                    dataField: 'fbReferral',
                    text: 'Campanha do Facebook',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style,
                    formatter: (_cell, row) => (
                      <div
                        style={{
                          maxWidth: '500px',
                          overflowX: 'auto',
                          scrollbarWidth: 'thin'
                        }}
                      >
                        {row?.referral?.headline ?? ''}
                      </div>
                    )
                  },
                  {
                    dataField: 'actions',
                    text: 'Ações',
                    sort: true,
                    style: icon_column_style,
                    headerStyle: individual_icon_header_style,
                    formatter: (_, row) => {
                      return (
                        <>
                          <ConversationDetails conversationData={row} />
                          <EditModal conversationData={row} />
                        </>
                      );
                    }
                  }
                ]}
              >
                {(props) => (
                  <div className="py-4 table-responsive">
                    <BootstrapTable
                      key={isMultiDownload ? 'multi' : 'single'} // força remount
                      {...props.baseProps}
                      bootstrap4={true}
                      bordered={false}
                      keyField="uniqueId"
                      classes="align-items-center"
                      selectRow={
                        isMultiDownload
                          ? {
                              mode: 'checkbox',
                              clickToSelect: true,
                              selected: selectedConversations.map(
                                (c) => c.uniqueId
                              ),
                              onSelect: (row, isSelect) => {
                                setSelectedConversations((prev) =>
                                  isSelect
                                    ? [...prev, row]
                                    : prev.filter(
                                        (r) => r.uniqueId !== row.uniqueId
                                      )
                                );
                              },
                              onSelectAll: (isSelect, rows) => {
                                setSelectedConversations(isSelect ? rows : []);
                              }
                            }
                          : undefined
                      }
                    />
                  </div>
                )}
              </ToolkitProvider>
            </Card>
          </div>
        </div>
      </Row>
    </>
  );
};

export default Analytical;
